import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { MatchListLayer } from '../components/Match/MatchListLayer'

export const MatchListPage = () => {
  return (
<MasterLayout>
    <MatchListLayer/>
</MasterLayout>  )
}
